import { Mapped } from "@omni/utils/context/mapped.context";
import { ReactNode } from "react";

import { useSidebarContext } from "@/components/Navigation/Sidebar/context/sidebar.context";
import { Depth } from "@/context/depth.context";

type Props = {
    children?: ReactNode;
};

export const SubCategories = ({ children }: Props) => {
    const { categories } = useSidebarContext();

    const subCategories = categories.slice(1);

    return (
        <Depth initial={1}>
            <Mapped array={subCategories}>{children}</Mapped>
        </Depth>
    );
};
